import { render } from "./relojtiempo.vue?vue&type=template&id=719319a0&scoped=true"
import script from "./relojtiempo.vue?vue&type=script&lang=js"
export * from "./relojtiempo.vue?vue&type=script&lang=js"

import "./relojtiempo.vue?vue&type=style&index=0&id=719319a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719319a0"]])

export default __exports__